import React from 'react';

import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle';
import { pageTitles } from '@/constants/pageTitles';

import styles from './InvitationRegisterErrorPage.module.scss';

const InvitationRegisterErrorPage: React.FC = () => (
  <SingleColumnTemplate>
    <div className={styles.InvitationRegisterErrorPage}>
      <Jumbotron>
        <JumbotronPanel panelHeaderTitle={pageTitles.invitationRegisterError}>
          <JumbotronTitle>登録を完了できませんでした</JumbotronTitle>
          <JumbotronDescription>
            再度招待メールをお受け取りの上、
            <br />
            登録の手続きを行ってください。
          </JumbotronDescription>
        </JumbotronPanel>
      </Jumbotron>
    </div>
  </SingleColumnTemplate>
);

export default InvitationRegisterErrorPage;
